import React, { useEffect } from 'react';
import AOS from 'aos';
import GLightbox from 'glightbox';
import 'aos/dist/aos.css';
import 'glightbox/dist/css/glightbox.min.css';
import './SocietyActivities.css'; // Create this file with your full CSS*/
import Seo from "../components/Seo";


const SocietyActivities = () => {
  useEffect(() => {
    AOS.init({ once: true });
    GLightbox({ selector: '.glightbox' });
  }, []);

  return (
    <>

    <Seo
        title="Society Activities – Community Engagement & CSR | Mortbuzz"
        description="Discover Mortbuzz's society activities and CSR initiatives. We actively participate in community development, social causes, and events that make a difference."
        keywords="society activities, CSR initiatives, community development, Mortbuzz events, social responsibility"
        canonical="https://www.mortbuzz.in/society-activities"
      />



    

    <div>
      <section className="gallery-section">
        <div className="container">
          {/* === 4th & 5th Jan === */}
          <div className="text-center" data-aos="fade-up">
            <div className="event-title">4th & 5th Jan – Mortbuzz Society Activity</div>
            <div className="event-subtitle text-white">
              Kumar Purva (Team Inbound), Picasso (Team Outbound), Urban Balance (Team Outbound), Belleza (Team Outbound), Sundarban DSK (Team Outbound), Prospera (Team Inbound)
            </div>
          </div>
          <div className="gallery-grid" data-aos="zoom-in">
            <GalleryItem src="/images/Society Activities/image (13).jpg" caption="Team Inbound - Kumar Purva" />
            <GalleryItem src="/images/Society Activities/image (19).jpg" caption="Team Outbound - Picasso" />
          </div>

          {/* === 8th & 9th Jan === */}
          <div className="text-center mt-5" data-aos="fade-up">
            <div className="event-title">8th & 9th Jan – Mortbuzz Society Activity</div>
            <div className="event-subtitle text-white">
              Joy Ville (Team Outbound), Grand Bay (Team Outbound), Evole Nyati (Team Inbound), Venkatesh Grafity (Team Outbound), Godrej Infinity ( Team Inbound)
            </div>
          </div>
          <div className="gallery-grid" data-aos="zoom-in">
            <GalleryItem src="/images/Society Activities/image (18).jpg" caption="Team Inbound - Joy Ville" />
            <GalleryItem src="/images/Society Activities/image (25).jpg" caption="Team Outbound - Grand Bay" />
          </div>

          {/* === 12th & 13th Jan === */}
          <div className="text-center mt-5" data-aos="fade-up">
            <div className="event-title">12th & 13th Jan – Mortbuzz Society Activity</div>
            <div className="event-subtitle text-white">
              Yashwin (Team Outbound), Rejuve Platino (Team Outbound), Oriyana (Team Inbound), Konark (Team Inbound)
            </div>
          </div>
          <div className="gallery-grid" data-aos="zoom-in">
            <GalleryItem src="/images/Society Activities/image (20).jpg" caption="Team Outbound - Yashwin" />
            <GalleryItem src="/images/Society Activities/image (13).jpg" caption="Team Inbound - Platino" />
          </div>
        </div>
      </section>

      {/* === Gallery Heading === */}
      <div className="gallery-header-wrapper">
        <h2 className="gallery-heading">Explore Moments of Society Activity</h2>
        <div className="gallery-subtitle">Snapshots from our vibrant society activities</div>
      </div>

      {/* === Aesthetic Gallery Section === */}
      <section className="aesthetic-gallery">
        <div className="container">
          <div className="aesthetic-gallery-grid">
            {imageUrls.map((url, idx) => (
              <div key={idx} className="aesthetic-img-box">
                <a href={url} className="glightbox">
                  <img src={url} className="img-fluid animated-gallery" alt="Activity-Photo" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>

    </>
  );
};

const GalleryItem = ({ src, caption }) => (
  <div className="gallery-item border border-primary">
    <img src={src} alt={caption} />
    <div className="gallery-caption">{caption}</div>
  </div>
);

const imageUrls = [
  "/images/Society Activities/image (1).jpg",
  "/images/Society Activities/image (2).jpg",
  "/images/Society Activities/image (3).jpg",
  "/images/Society Activities/image (4).jpg",
  "/images/Society Activities/image (5).jpg",
  "/images/Society Activities/image (6).jpg",
  "/images/Society Activities/image (7).jpg",
  "/images/Society Activities/image (8).jpg",
  "/images/Society Activities/image (9).jpg",
  "/images/Society Activities/image (10).jpg",
  "/images/Society Activities/image (11).jpg",
  "/images/Society Activities/image (12).jpg",
  "/images/Society Activities/image (13).jpg",
  "/images/Society Activities/image (14).jpg",
  "/images/Society Activities/image (15).jpg",
  "/images/Society Activities/image (16).jpg",
  "/images/Society Activities/image (17).jpg",
  "/images/Society Activities/image (18).jpg",
  "/images/Society Activities/image (19).jpg",
  "/images/Society Activities/image (20).jpg",
  "/images/Society Activities/image (21).jpg",
  "/images/Society Activities/image (22).jpg",
  "/images/Society Activities/image (23).jpg",
  "/images/Society Activities/image (24).jpg",
  "/images/Society Activities/image (25).jpg",
  "/images/Society Activities/image (26).jpg",
  "/images/Society Activities/image (27).jpg",
  "/images/Society Activities/image (28).jpg",
  "/images/Society Activities/image (29).jpg",
  "/images/Society Activities/image (30).jpg",
  
  // ... include all the rest of the aesthetic-gallery images
];

export default SocietyActivities;
